export enum SignerType {
    SIGNER_CUSTOMER = 'SIGNER_CUSTOMER',
    SIGNER_EXTERNAL = 'SIGNER_EXTERNAL',
    SIGNER_MARINA = 'SIGNER_MARINA',
    WITNESS = 'WITNESS',
}